import initialState from "../store/initial-state";
import {
  CLIENT_EMPTY,
  CLIENT_GET_DATA,
  CLIENT_GET_DATA_SUCCESS,
  CLIENT_GET_DATA_FAILURE,
  CLIENT_BREADCRUMB_GET_DATA,
  CLIENT_BREADCRUMB_GET_DATA_SUCCESS,
  CLIENT_BREADCRUMB_GET_DATA_FAILURE,
  CLIENT_ALL_BREADCRUMB_GET_DATA,
  CLIENT_ALL_BREADCRUMB_GET_DATA_SUCCESS,
  CLIENT_ALL_BREADCRUMB_GET_DATA_FAILURE,
  CLIENT_CREATE_FOLDER,
  CLIENT_CREATE_FOLDER_SUCCESS,
  CLIENT_CREATE_ROOT_FOLDER_SUCCESS,
  CLIENT_CREATE_FOLDER_FAILURE,
  CLIENT_SET_UPLOADING,
  CLIENT_UNSET_UPLOADING,
  CLIENT_DOWNLOAD_PROGRESS,
  CLIENT_EDIT_FOLDER,
  CLIENT_EDIT_FOLDER_SUCCESS,
  CLIENT_EDIT_FOLDER_FAILURE,
  CLIENT_DELETE_FOLDER,
  CLIENT_DELETE_FOLDER_SUCCESS,
  CLIENT_DELETE_FOLDER_FAILURE,
  CLIENT_MOVE_FOLDER,
  CLIENT_MOVE_FOLDER_SUCCESS,
  CLIENT_MOVE_FOLDER_FAILURE,
  CLIENT_SHARE_FOLDER,
  CLIENT_SHARE_FOLDER_SUCCESS,
  CLIENT_SHARE_FOLDER_FAILURE,
  CLIENT_CHANGE_LOGO,
  CLIENT_CHANGE_LOGO_SUCCESS,
  CLIENT_CHANGE_LOGO_FAILURE,
  CLIENT_SET_PID,
  CREATE_CLIENT_LIST,
  CREATE_CLIENT_LIST_SUCCESS,
  CREATE_CLIENT_LIST_FAILURE,
  DELETE_CLIENT_LIST,
  DELETE_CLIENT_LIST_SUCCESS,
  DELETE_CLIENT_LIST_FAILURE,
  UPDATE_CLIENT_LIST,
  UPDATE_CLIENT_LIST_SUCCESS,
  UPDATE_CLIENT_LIST_FAILURE,
  SET_QTY_FILES_ERROR,
  HANDLE_USER_ATTEMPS,
  SET_NUMBER_ATTEMPS,
  HANDLE_IS_TOUR_OPEN,
  HANDLE_IS_FETCHING_SAURON_REPORT,
  SHOW_VERSION_ASSET,
  HIDE_VERSION_ASSET,
  ADD_FILE_VERSION_ASSET,
  REMOVE_FILE_VERSION_ASSET,
  UPDATE_FILE_PROGRESS_VERSION_ASSET,
  SET_UPLOAD_OBJECT_TO_FILE_VERSION_ASSET,
  SET_ERROR_STATE_TO_FILE_VERSION_ASSET,
  SET_SUCCESS_STATE_TO_FILE_VERSION_ASSET,
  SET_IS_UPLOADING_VERSION,
  EMPTY_VERSION_ASSET,
  SET_VERSION_TAGS_VERSION_ASSET,
  CANCEL_UPLOAD_VERSION,
  UNSET_IS_UPLOADING_VERSION,
  ERROR_UPLOAD_VERSION,
  SET_TAGS_UPLOAD_VERSION,
  REMOVE_TAG_ASSET_VERSION,
  SET_USERS_OPTIONS,
  SET_MENTIONED_USERS,
  CREATE_CLIENT_MEDIA,
  CREATE_CLIENT_MEDIA_FAILURE,
  CREATE_CLIENT_MEDIA_SUCCESS,
  CREATE_CLIENT_STATUS,
  CREATE_CLIENT_STATUS_FAILURE,
  CREATE_CLIENT_STATUS_SUCCESS,
  DELETE_CLIENT_MEDIA,
  DELETE_CLIENT_MEDIA_FAILURE,
  DELETE_CLIENT_MEDIA_SUCCESS,
  DELETE_CLIENT_STATUS,
  DELETE_CLIENT_STATUS_FAILURE,
  DELETE_CLIENT_STATUS_SUCCESS,
  CLIENT_END_FOLDER_ACTION,
  SHARE_FOLDER_RESET,
  CLIENT_DATA_CLEAN,
  UPDATE_METADATA_CLIENT,
  CLIENT_ROOT_FOLDER_NAVBAR
} from "../constants/client-types";

import { modifyBreadCrumbWithChildren } from "../utils/index";

export default (state = initialState.client, action) => {
  switch (action.type) {
    case CLIENT_EMPTY:
      return {
        ...state,
        breadcrumb: [],
        rootFolderNavbar: [],
        root: null,
        isFetching: null,
        isInFolderAction: false,
        isDone: null,
        workclient: null,
        data: {
          _id: null,
          root: null
        },
        headers: null,
        error: null
      };

    case CLIENT_GET_DATA:
      return {
        ...state,
        isFetching: true,
        root: null,
        data: {
          ...state.data,
          _id: null,
          root: null
        },
        headers: null,
        error: null
      };

    case CLIENT_GET_DATA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        root: action.payload.data.root,
        workclient: action.payload.data._id,
        data: action.payload.data,
        headers: action.payload.headers,
        error: null
      };

    case CLIENT_GET_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        root: null,
        workclient: null,
        data: null,
        headers: null,
        error: action.payload
      };
    case CLIENT_DATA_CLEAN:
      return {
        ...state,
        data: null
      };

    case CLIENT_BREADCRUMB_GET_DATA:
      return {
        ...state,
        isFetching: true,
        isDone: false,
        // breadcrumb: [],
        error: null
      };

    case CLIENT_BREADCRUMB_GET_DATA_SUCCESS:
      const breadCrumbdsAllchildren = modifyBreadCrumbWithChildren(
        action.payload.data
      );
      return {
        ...state,
        isFetching: false,
        breadcrumb:
          action.payload.user.clientRole === "admin" ||
          action.payload.user.role === "admin"
            ? breadCrumbdsAllchildren
            : breadCrumbdsAllchildren.filter(
                r => r.group.length > 0 || r.type === "root"
              ),
        isDone: true,
        error: null
      };

    case CLIENT_BREADCRUMB_GET_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        isDone: false,
        breadcrumb: [],
        error: action.payload
      };

    case CLIENT_ALL_BREADCRUMB_GET_DATA:
      return {
        ...state,
        isFetchingAll: true,
        error: null
      };

    case CLIENT_ALL_BREADCRUMB_GET_DATA_SUCCESS:
      const breadCrumbdchildren = modifyBreadCrumbWithChildren(
        action.payload.data
      );
      return {
        ...state,
        isFetchingAll: false,
        breadcrumbAll: breadCrumbdchildren,
        error: null
      };

    case CLIENT_ALL_BREADCRUMB_GET_DATA_FAILURE:
      return {
        ...state,
        isFetchingAll: false,
        breadcrumbAll: [],
        error: action.payload
      };

    case CLIENT_CREATE_FOLDER:
      return {
        ...state,
        isInFolderAction: true,
        isFetching: true
      };

    case CLIENT_CREATE_FOLDER_SUCCESS:
      return {
        ...state,
        isFetching: false
        // breadcrumb: [...state.breadcrumb, {
        //   _id: action.payload._id,
        //   parents: [...action.payload.parents.map(r => {
        //     return {
        //       _id: r._id,
        //       name: r.name,
        //       type: r.type,
        //     }
        //   })],
        //   tagProtocol: action.payload.tagProtocol,
        //   longDescription: action.payload.longDescription,
        //   name: action.payload.name,
        //   type: 'folder',
        //   childs: [],
        //   nameLower: action.payload.name.toLowerCase(),
        //   group: []
        // }],
      };

    case CLIENT_CREATE_ROOT_FOLDER_SUCCESS:
      return {
        ...state,
        isFetching: true
      };

    case CLIENT_CREATE_FOLDER_FAILURE:
      return {
        ...state,
        isInFolderAction: false
      };

    case CLIENT_SET_UPLOADING:
      return {
        ...state,
        isUploading: true
      };

    case CLIENT_UNSET_UPLOADING:
      return {
        ...state,
        isUploading: false
      };

    case CLIENT_DOWNLOAD_PROGRESS:
      return {
        ...state,
        downloadProgress: action.payload
      };

    case CLIENT_EDIT_FOLDER:
      return {
        ...state,
        isInFolderAction: true,
        isFetching: true
      };

    case CLIENT_EDIT_FOLDER_SUCCESS:
      return {
        ...state,
        isFetching: true,
        breadcrumb: [
          ...state.breadcrumb.map(r => {
            return r._id === action.payload.data.folder
              ? {
                  ...r,
                  name: action.payload.data.name,
                  longDescription: action.payload.data.longDescription,
                  tagProtocol: action.payload.data.tagProtocol
                }
              : r;
          })
        ],
        isInFolderAction: false

        // breadcrumb: [
        //   ...state.breadcrumb.map(r => {
        //     return r._id === action.payload.id
        //       ? {
        //         ...r,
        //         name: action.payload.name,
        //         longDescription: action.payload.longDescription,
        //         tagProtocol: action.payload.tagProtocol
        //       }
        //       : r
        //   })
        // ]
      };

    case CLIENT_EDIT_FOLDER_FAILURE:
      return {
        ...state,
        error: action.payload,
        isInFolderAction: false
      };

    case CLIENT_DELETE_FOLDER:
      return {
        ...state,
        isInFolderAction: true
      };

    case CLIENT_DELETE_FOLDER_SUCCESS:
      return {
        ...state,
        isFetching: true
      };

    case CLIENT_DELETE_FOLDER_FAILURE:
      return {
        ...state,
        isInFolderAction: false,
        error: action.payload
      };

    case CLIENT_MOVE_FOLDER:
      return {
        ...state,
        isInFolderAction: true
      };

    case CLIENT_MOVE_FOLDER_SUCCESS:
      return {
        ...state,
        isFetching: true,
        isInFolderAction: false,
        error: ""
      };

    case CLIENT_MOVE_FOLDER_FAILURE:
      return {
        ...state,
        error: action.payload,
        isInFolderAction: false
      };

    case CLIENT_SHARE_FOLDER:
      return {
        ...state,
        isInFolderAction: true,
        isFetching: true,
        isShared: false
      };

    case SHARE_FOLDER_RESET:
      return {
        ...state,
        isShared: false
      };

    case CLIENT_SHARE_FOLDER_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isShared: true,
        isInFolderAction: false
      };

    case CLIENT_SHARE_FOLDER_FAILURE:
      return {
        ...state,
        error: action.payload,
        isInFolderAction: false,
        isFetching: false,
        isShared: false
      };

    case CLIENT_CHANGE_LOGO:
      return {
        ...state,
        isFetching: true
      };

    case CLIENT_CHANGE_LOGO_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          acountSetting: {
            ...state.acountSetting,
            logo: action.payload
          }
        },
        isFetching: false,
        error: null
      };

    case CLIENT_CHANGE_LOGO_FAILURE:
      return {
        ...state,
        isFetching: false,
        logoError: action.payload
      };

    case CLIENT_SET_PID:
      return {
        ...state,
        pidValue: action.payload
      };

    case CREATE_CLIENT_LIST:
      return {
        ...state,
        clientCreate: true
      };

    case CREATE_CLIENT_LIST_SUCCESS:
      return {
        ...state,
        clientCreate: false
      };

    case CREATE_CLIENT_LIST_FAILURE:
      return {
        ...state,
        clientCreate: false
      };

    case DELETE_CLIENT_LIST:
      return {
        ...state,
        deleteClient: true,
        statusDelete: "none"
      };

    case DELETE_CLIENT_LIST_SUCCESS:
      return {
        ...state,
        deleteClient: false,
        statusDelete: "success"
      };

    case DELETE_CLIENT_LIST_FAILURE:
      return {
        ...state,
        deleteClient: false,
        statusDelete: "failure"
      };

    case UPDATE_CLIENT_LIST:
      return {
        ...state,
        clientUpdate: true
      };

    case UPDATE_CLIENT_LIST_SUCCESS:
      return {
        ...state,
        clientUpdate: false,
        data: {
          ...state.data,
          dni: action.payload.data.dni,
          name: action.payload.data.name,
          agent: action.payload.data.agent,
          phone: action.payload.data.phone,
          email: action.payload.data.email,
          dartCustomField: action.payload.data.dartCustomField,
          contractedUsers: action.payload.data.contractedUsers,
          contractedSpace: action.payload.data.contractedSpace,
          media: action.payload.data.media,
          statusAsset: action.payload.data.statusAsset
        }
      };

    case UPDATE_CLIENT_LIST_FAILURE:
      return {
        ...state,
        clientUpdate: false
      };

    case SET_QTY_FILES_ERROR:
      return {
        ...state,
        qtyFilesError: action.payload.qtyFilesError
      };

    case HANDLE_USER_ATTEMPS:
      return {
        ...state,
        attemps: action.payload.attemps
      };

    case SET_NUMBER_ATTEMPS:
      return {
        ...state,
        numberAttemps: action.payload.numberAttemps
      };

    case HANDLE_IS_TOUR_OPEN:
      return {
        ...state,
        isTourOpen: action.payload.isTourOpen
      };

    case HANDLE_IS_FETCHING_SAURON_REPORT:
      return {
        ...state,
        isFetchingSauronReport: action.payload.isFetchingSauronReport
      };

    case SHOW_VERSION_ASSET: {
      return {
        ...state,
        uploadVersionAsset: {
          ...state.uploadVersionAsset,
          isShowingVersionAsset: false,
          itemSelected: {
            document: action.payload.itemSelected.document,
            userCreator: action.payload.itemSelected.userCreator,
            versions: action.payload.versions
          },
          breadCrumbs: action.payload.breadCrumbs,
          keyCollection: action.payload.keyCollection,
          from: action.payload.from
        }
      };
    }
    case HIDE_VERSION_ASSET: {
      return {
        ...state,
        uploadVersionAsset: {
          ...state.uploadVersionAsset,
          isShowingVersionAsset: false
        }
      };
    }
    case ADD_FILE_VERSION_ASSET: {
      return {
        ...state,
        uploadVersionAsset: {
          ...state.uploadVersionAsset,
          files: [...state.uploadVersionAsset.files, action.payload.file]
        }
      };
    }
    case REMOVE_FILE_VERSION_ASSET: {
      const { uuidtoRemove } = action.payload;
      return {
        ...state,
        uploadVersionAsset: {
          ...state.uploadVersionAsset,
          files: state.uploadVersionAsset.files.filter(
            file => file.uuid !== uuidtoRemove
          )
        }
      };
    }

    case UPDATE_FILE_PROGRESS_VERSION_ASSET: {
      const { file, e } = action.payload;
      return {
        ...state,
        uploadVersionAsset: {
          ...state.uploadVersionAsset,
          files: state.uploadVersionAsset.files.map(currentFile => {
            return {
              ...currentFile,
              state:
                currentFile.uuid === file.uuid
                  ? "inprogress"
                  : currentFile.state,
              progress:
                currentFile.uuid === file.uuid
                  ? (e.loaded / e.total) * 100
                  : currentFile.progress
            };
          })
        }
      };
    }
    case SET_UPLOAD_OBJECT_TO_FILE_VERSION_ASSET: {
      const { file, uploadObject } = action.payload;
      return {
        ...state,
        uploadVersionAsset: {
          ...state.uploadVersionAsset,
          files: state.uploadVersionAsset.files.map(currentFile => {
            return {
              ...currentFile,
              uploadObject:
                currentFile.uuid === file.uuid
                  ? uploadObject
                  : currentFile.uploadObject
            };
          })
        }
      };
    }
    case SET_ERROR_STATE_TO_FILE_VERSION_ASSET: {
      const { data } = action.payload;
      return {
        ...state,
        uploadVersionAsset: {
          ...state.uploadVersionAsset,
          files: state.uploadVersionAsset.files.map(file => {
            return {
              ...file,
              state: file.uuid === data.file.uuid ? "error" : file.state
            };
          })
        }
      };
    }

    case SET_SUCCESS_STATE_TO_FILE_VERSION_ASSET: {
      const { asset } = action.payload;
      return {
        ...state,
        uploadVersionAsset: {
          ...state.uploadVersionAsset,
          files: state.uploadVersionAsset.files.map(file => {
            return {
              ...file,
              state: file.uuid === asset.uuid ? "success" : file.state
            };
          })
        }
      };
    }

    case SET_IS_UPLOADING_VERSION: {
      return {
        ...state,
        isUploading: true,
        uploadVersionAsset: {
          ...state.uploadVersionAsset,
          isUploadingVersion: true
        }
      };
    }

    case UNSET_IS_UPLOADING_VERSION: {
      return {
        ...state,
        uploadVersionAsset: {
          ...state.uploadVersionAsset,
          isUploadingVersion: false
        }
      };
    }

    case EMPTY_VERSION_ASSET: {
      return {
        ...state,
        uploadVersionAsset: {
          isShowingVersionAsset: false,
          isUploadingVersion: false,

          itemSelected: {
            document: null,
            userCreator: null,
            versions: []
          },
          breadCrumbs: null,
          keyCollection: null,
          from: null,
          files: [],
          versionTags: [],
          tags: [],
          usersOption: [],
          mentionedUsers: []
        }
      };
    }
    case SET_VERSION_TAGS_VERSION_ASSET: {
      const { versionTags } = action.payload;
      return {
        ...state,
        uploadVersionAsset: {
          ...state.uploadVersionAsset,
          versionTags: versionTags
        }
      };
    }
    case CANCEL_UPLOAD_VERSION: {
      return {
        ...state,
        uploadVersionAsset: {
          ...state.uploadVersionAsset,
          isUploadingVersion: false,
          files: state.uploadVersionAsset.files.map(file => {
            return {
              ...file,
              progress: 0,
              state: "waiting",
              uploadObject: null
            };
          })
        }
      };
    }

    case ERROR_UPLOAD_VERSION: {
      return {
        ...state,
        uploadVersionAsset: {
          ...state.uploadVersionAsset,
          isUploadingVersion: false,
          files: state.uploadVersionAsset.files.map(file => {
            return {
              ...file,
              progress: 0,
              state: "waiting",
              uploadObject: null
            };
          })
        }
      };
    }

    case SET_TAGS_UPLOAD_VERSION: {
      const { tags } = action.payload;

      return {
        ...state,
        uploadVersionAsset: {
          ...state.uploadVersionAsset,

          tags: [...tags]
        }
      };
    }

    case REMOVE_TAG_ASSET_VERSION: {
      const { tagToRemove } = action.payload;
      return {
        ...state,
        uploadVersionAsset: {
          ...state.uploadVersionAsset,
          tags: state.uploadVersionAsset.tags.filter(tag => tag !== tagToRemove)
        }
      };
    }

    case SET_USERS_OPTIONS: {
      const { usersOption } = action.payload;
      return {
        ...state,
        uploadVersionAsset: {
          ...state.uploadVersionAsset,
          usersOption: usersOption
        }
      };
    }

    case SET_MENTIONED_USERS: {
      const { mentionedUsers } = action.payload;
      return {
        ...state,
        uploadVersionAsset: {
          ...state.uploadVersionAsset,
          mentionedUsers: mentionedUsers
        }
      };
    }

    case CREATE_CLIENT_MEDIA: {
      return {
        ...state,
        clientUpdate: true
      };
    }

    case CREATE_CLIENT_MEDIA_SUCCESS:
      return {
        ...state,
        clientUpdate: false,
        data: {
          ...state.data,
          media: action.payload.data.media
        }
      };

    case CREATE_CLIENT_MEDIA_FAILURE:
      return {
        ...state,
        clientUpdate: false
      };

    case CREATE_CLIENT_STATUS: {
      return {
        ...state,
        clientUpdate: true
      };
    }

    case CREATE_CLIENT_STATUS_SUCCESS:
      return {
        ...state,
        clientUpdate: false,
        data: {
          ...state.data,
          statusAsset: action.payload.data.statusAsset
        }
      };

    case CREATE_CLIENT_STATUS_FAILURE:
      return {
        ...state,
        clientUpdate: false
      };

    case DELETE_CLIENT_MEDIA: {
      return {
        ...state,
        clientUpdate: true
      };
    }

    case DELETE_CLIENT_MEDIA_SUCCESS:
      return {
        ...state,
        clientUpdate: false,
        data: {
          ...state.data,
          media: state.data.media.filter(
            m => m._id !== action.payload.data.deletedMediaId
          )
        }
      };

    case DELETE_CLIENT_MEDIA_FAILURE:
      return {
        ...state,
        clientUpdate: false
      };

    case DELETE_CLIENT_STATUS: {
      return {
        ...state,
        clientUpdate: true
      };
    }

    case DELETE_CLIENT_STATUS_SUCCESS:
      return {
        ...state,
        clientUpdate: false,
        data: {
          ...state.data,
          statusAsset: state.data.statusAsset.filter(
            m => m._id !== action.payload.data.deletedStatusId
          )
        }
      };

    case DELETE_CLIENT_STATUS_FAILURE:
      return {
        ...state,
        clientUpdate: false
      };

    case CLIENT_END_FOLDER_ACTION:
      return {
        ...state,
        isInFolderAction: false
      };
    case UPDATE_METADATA_CLIENT:
      return {
        ...state,
        ...action.payload
      };

    case CLIENT_ROOT_FOLDER_NAVBAR:
      return {
        ...state,
        rootFolderNavbar: action.payload
      };
    default:
      return { ...state };
  }
};
